import { connect } from 'react-redux'

import ReduxStoreInterface from '../../interfaces/client/ReduxStore'
import ClientPassengerInterface from '../../interfaces/client/Passenger'
import NewBookingRowInterface from '../../interfaces/client/NewBookingRow'
import NewBookingTravelClassInterface from '../../interfaces/client/NewBookingTravelClass'

import constants from '../../config/constants'

import recursivelyCreateNewBookingTravelClassRows from '../../utils/recursivelyCreateNewBookingTravelClassRows'

import NewBookingFormComposeRows from '../../components/NewBookingFormComposeRows'

const { economyTravelClass, smartTravelClass } = constants

export interface NewBookingFormComposeRowsPropsInterface {
  smartClassAllotmentCount: number
  economyAllotmentCount: number
  departureFlightId: string
  isTOFlight: boolean
}

export const mapStateToProps = (
  state: ReduxStoreInterface,
  props: NewBookingFormComposeRowsPropsInterface
) => {
  const {
    smartClassAllotmentCount,
    economyAllotmentCount,
    departureFlightId,
    isTOFlight,
  } = props

  const existingPassengers = state.uploadedPassengers.allIds.map(
    (id: string) => state.uploadedPassengers.byId[id]
  )

  const smartClassRows: NewBookingTravelClassInterface[] = recursivelyCreateNewBookingTravelClassRows(
    smartClassAllotmentCount,
    smartTravelClass,
    []
  )
  const economyClassRows: NewBookingTravelClassInterface[] = recursivelyCreateNewBookingTravelClassRows(
    economyAllotmentCount,
    economyTravelClass,
    smartClassRows
  )

  const rows: NewBookingRowInterface[] = economyClassRows.map(
    (rowType: NewBookingTravelClassInterface, index: number) => {
      const existingPassenger: ClientPassengerInterface =
        existingPassengers[index]

      const passengerId = existingPassenger
        ? existingPassenger.id
        : String(index)

      return {
        ...rowType,
        passengerId,
        rowId: index + 1,
      }
    }
  )

  return {
    departureFlightId,
    isTOFlight,
    rows,
  }
}

export default connect(mapStateToProps)(NewBookingFormComposeRows)
